import script from "./upcoming.vue?vue&type=script&setup=true&lang=js"
export * from "./upcoming.vue?vue&type=script&setup=true&lang=js"

import "./upcoming.vue?vue&type=style&index=0&id=45b2e454&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45b2e454"]])

export default __exports__